export default "//uniclient-edge-assets.lmndstaging.com/logo__at__99baf3c6f97d9706ada2a9c5c9f32b21.svg"